import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

const LABELS = {
  text_generations: "AI generations",
  image_generations: "AI visuals",
  scheduled_posts: "Scheduled posts",
  connected_accounts: "Connected accounts",
};

export const useUsage = () => {
  const [usage, setUsage] = useState(null);
  const reload = () => api.get("/engine/usage").then((r) => setUsage(r.data)).catch(() => setUsage(false));
  useEffect(() => {
    reload();
  }, []);
  return { usage, reloadUsage: reload };
};

export default function UsageMeter({ usage, metrics = ["text_generations", "image_generations"], testId = "usage-meter" }) {
  if (!usage) return null;
  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid={testId}>
      {metrics.map((m) => {
        const limit = usage.limits?.[m] ?? 0;
        const used = usage.used?.[m] ?? 0;
        const pct = limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 100;
        return (
          <div
            key={m}
            className="rounded-2xl border border-slate-200 bg-white p-4 soft-shadow"
            data-testid={`usage-${m.replace(/_/g, "-")}`}
          >
            <div className="flex items-baseline justify-between gap-2">
              <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">{LABELS[m] || m}</p>
              <p className="text-sm font-semibold text-slate-900">
                {used} / {limit}
              </p>
            </div>
            <div className="mt-3 h-1.5 rounded-full bg-slate-100">
              <div
                className={`h-1.5 rounded-full ${pct >= 100 ? "bg-red-500" : pct >= 80 ? "bg-amber-500" : "bg-[#F95738]"}`}
                style={{ width: `${pct}%` }}
                aria-hidden="true"
              />
            </div>
            <p className="mt-2 text-xs text-slate-500">
              {usage.plan?.name} plan · resets at the start of next month
            </p>
          </div>
        );
      })}
    </div>
  );
}
